// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".1e40f166f362f4d58ce1017115fdae48f3fc23bd.chunk.js";
};